// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterBox_container__LlI95","children":"FilterBox_children__1fFDB"};